import React from 'react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const tips = [
  {
    title: 'Build a daily routine',
    body:
      'Pets thrive on predictability. Consistent meal times, walk times and rest windows matter more than the exact schedule.',
  },
  {
    title: 'Walks are mental, not just physical',
    body:
      'Let your dog sniff. A 20-minute walk where they get to explore is often more tiring than a 40-minute brisk one.',
  },
  {
    title: 'Hydration first, especially in summer',
    body:
      'Fresh water at all times, plus a second bowl on hot days. Watch for panting, and avoid mid-day walks in peak heat.',
  },
  {
    title: 'Socialization windows matter',
    body:
      'Early, positive exposure to other pets, people and environments pays off for life. Day care and short stays help.',
  },
  {
    title: 'Don\'t skip grooming',
    body:
      'Regular brushing, nail trims and ear checks prevent small problems from becoming vet visits.',
  },
  {
    title: 'Train with the food they love',
    body:
      'Reward markers, small treats, short sessions. Five minutes a day beats one hour on a Sunday.',
  },
];

const PetCareTips = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="bg-amber-50 pt-40 pb-12 sm:pt-48 sm:pb-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Field notes</p>
        <h1 className="mt-3 max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-neutral-900 sm:text-5xl">
          Small things, repeated daily, that make a real difference.
        </h1>
        <p className="mt-5 max-w-2xl text-base text-neutral-700 sm:text-lg">
          Pulled from years on the floor at PetCart Nest — what we see actually works, in plain
          language.
        </p>
      </div>
    </section>

    <section className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {tips.map((t, i) => (
            <article
              key={t.title}
              className="relative rounded-2xl border border-neutral-200 bg-white p-6 transition-colors hover:border-neutral-900 sm:p-7"
            >
              <span className="text-5xl font-semibold tracking-tight text-primary/30 sm:text-6xl">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-lg font-semibold text-neutral-900">{t.title}</h3>
              <p className="mt-2 text-sm leading-6 text-neutral-600">{t.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-neutral-50 py-14 sm:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-sm uppercase tracking-wider text-neutral-500">Want this expanded?</p>
        <p className="mt-3 text-xl font-medium text-neutral-900 sm:text-2xl">
          Tell us what you want covered next — we write these based on what pet parents actually
          ask.
        </p>
        <a
          href="mailto:shekhar@petcart.com?subject=Suggest%20a%20tip"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-neutral-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-neutral-800"
        >
          Suggest a topic
        </a>
      </div>
    </section>

    <Footer />
  </div>
);

export default PetCareTips;
